import { useCallback, useMemo } from 'react'

import { useBookingContext } from '@providers/booking'
import type { ContinueGuard } from '@providers/booking_continue'
import { useModalDecision } from '@providers/booking_continue/use_modal_decision'

export const useWaitlistContinueGuard = () => {
  const bookingCtx = useBookingContext()
  const decision = useModalDecision()

  const run = useCallback(
    () => (bookingCtx.state.cart.bookWaitlist ? decision.requestDecision() : Promise.resolve(true)),
    [bookingCtx.state.cart.bookWaitlist, decision]
  )

  const guard = useMemo<ContinueGuard>(
    () => ({ id: 'waitlist-confirmation', run, cancel: decision.cancel }),
    [decision.cancel, run]
  )

  const selectedDay = bookingCtx.state.cart.groups[0]?.daycareSelected?.[0]?.date

  return {
    guard,
    modalProps: {
      isOpen: decision.isOpen,
      date: selectedDay,
      onConfirm: decision.confirm,
      onClose: decision.cancel,
    },
  }
}
